import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { MANIPULATE_BENEFICIARIES_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class DeleteBeneficiaryRequest extends BaseApiRequest {
  method = METHOD.HTTP.DELETE;

  body = {};

  url = MANIPULATE_BENEFICIARIES_URL;

  constructor(paramList) {
    super();
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
